export default __webpack_public_path__ + "static/media/MNAK.f1877b79.png";